import { useState } from "react";
import { AlertTriangle, CloudOff, RotateCw, X } from "lucide-react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { usePOS } from "@/context/POSContext";
import { forceSyncDevice } from "@/lib/forceSync";

export default function OfflineStatus() {
  const { token, serverOnline, pendingCount, checkServer, offlineKotWarning, dismissOfflineKotWarning } = usePOS();
  const location = useLocation();
  const [syncing, setSyncing] = useState(false);
  // Retry is a full sync, not just the till queue: it re-checks the server
  // and sends every order this device still owes it, then says what happened.
  const retry = async () => {
    if (syncing) return;
    setSyncing(true);
    try {
      const { ok, message } = await forceSyncDevice(token, checkServer);
      (ok ? toast.success : toast.error)(message, { duration: ok ? 4000 : 10000 });
    } finally {
      setSyncing(false);
    }
  };
  if (serverOnline && pendingCount === 0 && !offlineKotWarning) return null;
  return <div className="offline-status-stack" data-testid="offline-status-stack">
    {(!serverOnline || pendingCount > 0) && <div className="offline-queue-banner" data-testid="offline-queue-banner"><CloudOff/><strong>{serverOnline ? "Sync pending" : "Offline mode"}</strong><span>{pendingCount} action{pendingCount === 1 ? "" : "s"} queued safely on this device</span><button onClick={retry} disabled={syncing} aria-label="Sync now" data-testid="retry-offline-sync-button"><RotateCw className={syncing ? "animate-spin" : ""}/>{syncing ? "Syncing…" : "Retry"}</button></div>}
    {offlineKotWarning && location.pathname === "/captain" && <div className="offline-kot-warning" role="alert" data-testid="offline-kot-warning"><AlertTriangle/><div><strong>SERVER OFFLINE: KOT saved locally</strong><span>Please inform the kitchen manually. It will sync automatically when the server returns.</span></div><button onClick={dismissOfflineKotWarning} data-testid="dismiss-offline-kot-warning-button"><X/></button></div>}
  </div>;
}